import KioskLogo from "./KioskLogo";
import KioskBackgroundSlider from "./KioskBackgroundSlider";
import useKioskTranslation from "./useKioskTranslation";

const KioskClosedScreen = () => {
  const { t } = useKioskTranslation();

  return (
    <KioskBackgroundSlider overlayClassName="absolute inset-0 z-10 bg-[linear-gradient(to_bottom,rgba(0,0,0,0.5),rgba(0,0,0,0.84))]">
      <div className="flex max-w-[880px] flex-col items-center rounded-[2.75rem] border border-white/20 bg-black/40 px-16 py-16 text-center shadow-[0_28px_80px_rgba(0,0,0,0.4)] backdrop-blur-md">
        <div className="mb-8 flex items-center justify-center rounded-full border border-white/20 bg-white/10">
          <KioskLogo className="w-180 h-auto object-fit m-0 p-0" />
        </div>
        <span className="rounded-full border border-white/25 bg-white/10 px-8 py-3 text-[20px] font-semibold tracking-[0.16em] text-white/90 uppercase">
          {t("closedBadge")}
        </span>
        <h1 className="mt-8 text-[72px] font-black leading-[1.08] tracking-[0.5px] text-white">
          {t("notAvailable")}
        </h1>
        <p className="mt-6 max-w-[640px] text-[28px] font-medium leading-snug text-white/80">
          {t("currentlyClosed")}
        </p>
      </div>
    </KioskBackgroundSlider>
  );
};

export default KioskClosedScreen;
